<template>
  <div class="content-header row">
    <div class="content-header-left col-xs-12 mb-1">
      <h2 class="content-header-title">{{title}} <slot name="additional-header-info"></slot></h2>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContentHeader",
  props: {
    title: String,
  },
};
</script>